export const getDirectionAttribute = (isDeparture: boolean, name: string) => {
	const attribute: Record<string, boolean> = {};
	const direction = isDeparture ? 'departure' : 'arrival';

	attribute[`data-${direction}-${name}`] = true;

	return attribute;
};
